import styled from 'styled-components';
import Button, {
  ButtonLink,
} from '@womcorp/wom-miwom-ui-kit/dist/components/Button';
import { Ghost } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';

const LayoutWrapperStyled = styled.div`
  align-items: center;
  background: white;
  display: flex;
  height: 100vh;
  justify-content: center;
  padding: 32px;

  :before {
    content: '';
    background: linear-gradient(270deg, #ed1e79 0%, #451287 100%);
    height: 6px;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const ContentStyled = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 312px;

  @media (min-width: 769px) {
    max-width: 360px;
  }
`;

const GhostSvgStyled = styled(Ghost)`
  flex-shrink: 0;
`;

const TitleStyled = styled.h1`
  color: #494c66;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  margin-top: 16px;
  text-align: center;
`;

const MessageStyled = styled.p`
  color: #494c66;
  font-size: 16px;
  font-weight: 300;
  line-height: 20px;
  margin-top: 8px;
  text-align: center;
`;

const ButtonStyled = styled(Button)`
  && {
    margin-top: 16px;
    max-width: 180px;
  }
`;

const ButtonLinkStyled = styled(ButtonLink)`
  && {
    font-size: 14px;
    line-height: 20px;
    margin-top: 16px;
  }
`;

export {
  LayoutWrapperStyled,
  ContentStyled,
  GhostSvgStyled,
  TitleStyled,
  MessageStyled,
  ButtonStyled,
  ButtonLinkStyled,
};
